import { Module }       from 'vuex';
import { RootState }    from '@/store/store.types';
import state            from '@/views/rate-checker-configuration/rate-checker/store/rate-checker.state.store';
import actions          from '@/views/rate-checker-configuration/rate-checker/store/rate-checker.actions.store';
import mutations        from '@/views/rate-checker-configuration/rate-checker/store/rate-checker.mutations.store';
import { RateCheckerState } from '@/views/rate-checker-configuration/rate-checker/rate-checker.types';

const store: Module<RateCheckerState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default store;
